import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { DragDropContext } from "react-beautiful-dnd";
// css
import "./Teams.modules.css";
// prime react
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { InputText } from "primereact/inputtext";
import { BreadCrumb } from "primereact/breadcrumb";
import { ColorPicker } from "primereact/colorpicker";
// components
import Modal from "../../components/modal/Modal";
import Select from "../../components/input/Select";
import MultipleSelect from "../../components/input/MultipleSelect";
// services
import { getTeam } from "../../services/GlobalRoles/getTeam";
import { putTeams } from "../../services/Teams/putTeams";
import { getIdTeam } from "../../services/Teams/getTeamId";
import { postTeams } from "../../services/Teams/postTeams";
import { patchEnterprise } from "../../services/Enterprise/patchEnterprise";
// utils
import { Members } from "./Members";
import { useOptionsSelect } from "../../hooks/useOptionsSelect";
import { queryClient } from "../../utils/queryClient";
import { useAppContext } from "../../context/AppContext";
import usePermission from "../../hooks/usePermission";
//assets
import noData from "../../assets/errors/noData.png";

function Teams() {
  usePermission("101"); // Visualizar Timwa
  const { id } = useParams();
  const { state } = useLocation();
  const { permissions } = useAppContext();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loadingTeams, setLoadingTeams] = useState(false);
  const [visible, setVisible] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [teams, setTeams] = useState(false);
  const [all, setAll] = useState(null);
  const [showSelects, setShowSelects] = useState(false);
  const [modalContent, setModalContent] = useState(
    permissions.includes("102") //Cadastrar Times
  );
  const [showTeams, setShowTeams] = useState(false);
  const [teamsSelected, setTeamsSelected] = useState([]);
  const [showButton, setShowButton] = useState(false);
  const [nameTeam, setNameTeam] = useState("");
  const [color, setColor] = useState("000");
  const [newTeam, setNewTeam] = useState(false);
  const [selectedForeignTeams, setSelectedForeignTeams] = useState(false);
  const [loadingLinkTeam, setLoadingLinkTeam] = useState(false);

  const { enterprise, isLoadingEnterprises, selectEnterprise } =
    useOptionsSelect();
  usePermission("101");
  const form = useForm();
  const errors = form.formState.errors;
  const item = [
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/teams/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Times
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  // Primeira consulta para buscar os times do empreendimento
  const {
    data: teamEnterprise,
    refetch,
    isRefetching,
    isLoading: isLoadingTeamEnterprise,
  } = useQuery({
    queryKey: [`teams${id}`],
    queryFn: () => getIdTeam(id),
  });

  // Segunda consulta para buscar os times com seus membros
  const {
    data: team,
    isLoading,
    refetch: refetchMembers,
    isRefetching: isRefetchingMembers,
  } = useQuery({
    queryKey: [`team${id}`],
    queryFn: () => getTeamsAll(teamEnterprise, true),
    enabled: !!teamEnterprise, // Habilita a consulta somente se teamEnterprise estiver disponível
  });

  const { mutateAsync: handleSelectedForeignTeamsFn } = useMutation({
    mutationFn: handleSelectedForeignTeams,
    onSuccess(res, variables) {
      queryClient.setQueryData([`team${id}`], (data) => {
        //console.log("Res query: ", res);
        //console.log("Variable query: ", variables);
        //console.log("New Objetct: ", [...data, ...res]);
        return [...data, ...res];
      });

      queryClient.setQueryData([`teams${id}`], (data) => {
        return [...data, ...res];
      });
    },
  });

  async function getTeamsAll(a, switchId) {
    try {
      // Mapeia as equipes para uma lista de promessas que buscam os dados de cada equipe
      const allTeamsDataPromises = a.map((t) =>
        getTeam(switchId ? t.id : t.code)
      );

      // Espera até que todas as promessas sejam concluídas
      const allTeamsData = await Promise.all(allTeamsDataPromises);

      //console.log("Res All Teams: ", allTeamsData);
      return allTeamsData;
    } catch (error) {
      console.error("Error fetching teams data:", error);
      throw new Error(error); // Relança o erro para que possa ser tratado pelo chamador da função
    }
  }

  useEffect(() => {
    if (all) {
      async function fetchTeams() {
        await getTeamsAll(all);
      }
      fetchTeams();
    }
  }, [all]);

  const { mutateAsync: postTeamsFn } = useMutation({
    mutationFn: postTeams,
    onSuccess(dataTeams, variables) {
      const emptyTeam = {
        id: dataTeams.data.id,
        name: dataTeams.data.name,
        created_at: dataTeams.data.created_at,
        updated_at: dataTeams.data.updated_at,
        color: variables.color,
        members: [],
      };
      // toast.success(dataTeams.success);
      //console.log(team);
      //console.log(emptyTeam);

      if (!team) {
        setAll([emptyTeam]);
      }

      queryClient.setQueryData([`team${id}`], (data) => {
        //console.log(...data);
        //console.log(emptyTeam);
        return [...data, emptyTeam];
      });

      queryClient.setQueryData([`teams${id}`], (data) => {
        return [...data, emptyTeam];
      });

      refetch();
      setLoading(false);
      setVisible(false);
      setNewTeam(false);
      setNameTeam("");
      setModalContent(true);

      return dataTeams;
    },
    onError(error) {
      toast.error(
        "Oops algo deu errado, " + error?.response?.data?.errors?.name[0]
      );
      //console.log(error);
      setLoading(false);
      setNameTeam("");
      // setNewTeam(false);
      // setModalContent(true);
      return "Deu ruim";
    },
  });

  async function addEmptyTeam() {
    setLoading(true);
    //console.log(nameTeam);
    const createTeam = {
      name: nameTeam,
      color: `#${color}`,
    };

    //console.log(createTeam);
    try {
      const request = await postTeamsFn(createTeam);

      //console.log("Request: ", request);
      //console.log(id);

      const sendData = {
        id,
        data: {
          team_id: request.data.id,
        },
      };

      await patchEnterprise(sendData);

      //console.log(linkEnterprise);
      //console.log(all);

      if (!all) {
        setAll([{ name: request.data.name, code: request.data.id }]);
        setTeams(true);
        setLoading(false);
        setVisible(false);
        setNameTeam("");
        setNewTeam(false);
        setModalContent(true);
        return;
      }

      all.push({ name: request.data.name, code: request.data.id });
    } catch (error) {
      return error;
    }
  }

  function handleSelect() {
    setModalContent(false);
    setShowSelects(true);
  }

  async function handleEnterprise(value) {
    setLoadingTeams(true);
    selectEnterprise(value);
    //console.log(value);
    if (value) {
      const getEnterprise = await getIdTeam(value);
      //console.log(getEnterprise);

      const teamsSelect =
        getEnterprise &&
        getEnterprise.map((team) => ({
          name: team.name,
          code: team.id,
        }));

      setTeamsSelected(teamsSelect);

      setShowTeams(true);
    }
    setLoadingTeams(false);
  }

  async function linkTeam(teamId) {
    //console.log("Team ID: ", teamId)
    const sendData = {
      id,
      data: {
        team_id: teamId,
      },
    };
    try {
      const linkEnterprise = await patchEnterprise(sendData);
      //console.log("Link: ", linkEnterprise)
    } catch (error) {
      toast.error(error.response.data.error.message);
      console.error("Link team error: ", error);
    }
  }

  async function handleSelectedForeignTeams() {
    setLoadingLinkTeam(true);
    const allForeignTeams = await getTeamsAll(selectedForeignTeams);
    //console.log("Actual Teams: ", teamEnterprise);
    //console.log("Res All: ", allForeignTeams);

    const allForeignTeamsLinkPromises = allForeignTeams.map(async (a) => {
      if (teamEnterprise.find((t) => t.id === a.id)) {
        toast.error(
          "Você não pode vincular o mesmo time no mesmo empreendimento."
        );
        return null; // Retorna null para evitar que um valor não promessa seja passado para Promise.all
      } else {
        await linkTeam(a.id);
        return a;
      }
    });

    try {
      const res = await Promise.all(allForeignTeamsLinkPromises);
      //console.log("Promises Response: ", res.filter(Boolean)); // Filtra para remover valores null
      setLoadingLinkTeam(false);
      return res.filter(Boolean); // Retorna somente os valores não nulos
    } catch (error) {
      console.error("Erro ao vincular times:", error);
      throw new Error(error); // Lança o erro para ser tratado externamente
    }
  }

  function handleNewTeam() {
    setModalContent(false);
    setNewTeam(true);
  }

  function handleTeams(e) {
    //console.log("Handle Teams e: ", e);
    //console.log(teamsSelected);

    e.map((a) => {
      //console.log(a);
      //console.log(teamEnterprise.find(t => t.id === a.code));
      if (teamEnterprise.find((t) => t.id === a.code)) {
        setShowButton(false);
        toast.error(
          "Você não pode vincular o mesmo time no mesmo empreendimento."
        );
      } else {
        setSelectedForeignTeams(e);
        setShowButton(true);
      }
    });
  }

  function closeModal() {
    setVisible(!visible);
    setNewTeam(false);
    setShowSelects(false);
    setModalContent(true);
  }

  async function handleDragEnd(result) {
    console.log("Result: ", result);
    // const notification = toast.loading("Por favor aguarde...");
    const { destination, source } = result;
    // Verifica se a operação de arrastar está ativa
    if (
      !result.combine &&
      (!destination ||
        (destination.droppableId === source.droppableId &&
          destination.index === source.index))
    ) {
      return; // Se não houver operação de arrastar ativa ou se o item foi solto no mesmo local, saia
    }

    // Convertendo ID
    const sourceTeamId = parseInt(source.droppableId);
    const destinationTeamId = parseInt(destination.droppableId);
    parseInt(destination.droppableId);

    //console.log("da onde veio ", sourceTeamId);
    //console.log("destino ", destinationTeamId);

    // Verifica se uma operação de soltar está ocorrendo antes de concluir a animação
    if (sourceTeamId === destinationTeamId) return;

    const updatedTeams = [...team];

    // Atualiza os times após o arrastar e soltar
    const sourceTeamIndex = updatedTeams.findIndex(
      (team) => team.id === sourceTeamId
    );
    const destinationTeamIndex = updatedTeams.findIndex(
      (team) => team.id === destinationTeamId
    );

    // Verifica se os índices de equipe são válidos
    if (
      sourceTeamIndex === -1 ||
      destinationTeamIndex === -1 ||
      !updatedTeams[sourceTeamIndex].members ||
      !updatedTeams[destinationTeamIndex].members
    ) {
      // toast.update(notification, {
      //   render: "Índices de equipe inválidos ou membros indefinidos.",
      //   autoClose: 1000,
      //   type: "error",
      //   isLoading: false,
      // });
      toast.error("Índices de equipe inválidos ou membros indefinidos.");
      return;
    }

    // Crie uma cópia do membro antes de removê-lo do array de membros do time de origem
    const draggedItem = {
      ...updatedTeams[sourceTeamIndex].members[source.index],
    };

    // Remova o membro do array de membros do time de origem
    updatedTeams[sourceTeamIndex].members.splice(source.index, 1);

    // Verifique se o membro já está no time de destino
    const memberAlreadyExists = updatedTeams[destinationTeamIndex].members.some(
      (member) => member.id === draggedItem.id
    );

    if (memberAlreadyExists) {
      toast.warning("O membro já está no time de destino.");

      // Reinserir o membro de volta no time de origem, na posição original
      updatedTeams[sourceTeamIndex].members.splice(source.index, 0, draggedItem);

      // Recarregar os dados ou fazer qualquer ação necessária
      refetch();

      return;
    } else {
      // Insira o membro no array de membros do time de destino
      updatedTeams[destinationTeamIndex].members.splice(
        destination.index,
        0,
        draggedItem
      );

      // //console.log(updatedTeams);
    }

    async function updateTeams() {
      // Contador para acompanhar o número de requisições pendentes
      // let requestsPending = updatedTeams.length;

      // Iterar sobre cada time em updatedTeams
      for (const team of updatedTeams) {
        // Montar os dados para a requisição de atualização
        const data = {
          team_id: team.id,
          members: team.members.map((member) => member.id),
        };

        // Fazer a requisição de atualização
        try {
          await putTeams(data);
          //          // //console.log(response);
          // Decrementar o contador quando uma requisição é concluída
          // requestsPending--;
          // Verificar se todas as requisições foram concluídas
          // if (requestsPending === 0) {
          //          //   //console.log("Todas as atualizações foram concluídas.");
          //   // Aqui você pode fazer qualquer coisa que queira após todas as atualizações serem concluídas
          // }
          // toast.update(notification, {
          //   render: `Time atualizado com sucesso!`,
          //   autoClose: 1000,
          //   type: "success",
          //   isLoading: false,
          // });
        } catch (error) {
          toast.error(`Erro ao atualizar o time ${team.name}.`, error);
          // toast.update(notification, {
          //   render: `Erro ao atualizar o time ${team.name}.`,
          //   autoClose: 1000,
          //   type: "error",
          //   isLoading: false,
          // });
          // Se houver um erro, você ainda precisa decrementar o contador
          // requestsPending--;
          return;
        }
      }
    }

    // Chamar a função para atualizar os times
    updateTeams()
      .then(() => {
        // Aqui você pode fazer qualquer coisa que queira após todas as atualizações serem concluídas
        //console.log("Todas as atualizações foram concluídas.");
        refetch();
        // setTeams(updatedTeams);
      })
      .catch((error) => {
        console.error("Erro ao atualizar os times:", error);
      });
  }

  return (
    <>
      {isLoading || isLoadingTeamEnterprise ? (
        <Skeleton width="100%" height="80vh" />
      ) : (
        <>
          <div className="row d-flex justify-content-between mb-3">
            <div className="col-md-5">
              <BreadCrumb model={item} home={home} className="breadCrumb" />
            </div>
            {permissions.includes("102") && ( // Cadastrar Times
              <div className="col-md-7">
                <div className="float-end">
                  <Button
                    rounded
                    label="Novo Time"
                    icon="fa fa-plus"
                    onClick={() => setVisible(true)}
                    loading={loading}
                    className="p-inputtext-sm me-2 m-auto w-100"
                  />
                </div>
              </div>
            )}
          </div>
          {team.length === 0 ? (
            <div className="d-flex flex-column justify-content-center align-items-center text-center w-100">
              <img src={noData} alt="error" width="400px" />
              <h4>Não encontramos nenhum time por aqui</h4>
            </div>
          ) : (
            <div className="layout__wrapper">
              <div className="layout__header">
                <div className="app-bar">
                  <div className="app-bar__title">Times</div>
                </div>
              </div>
              <DragDropContext onDragEnd={handleDragEnd}>
                <div className="items-container d-flex">
                  {team && teamEnterprise && (
                    <Members
                      teams={team}
                      refetch={refetch}
                      isRefetching={isRefetching}
                      loading={loading}
                      setLoading={setLoading}
                      refetchMembers={refetchMembers}
                    />
                  )}
                </div>
              </DragDropContext>
            </div>
          )}
        </>
      )}

      <Modal
        visible={visible}
        dynamicTitle={"Deseja vincular um time de outro empreendimento ?"}
        onHide={closeModal}
        closable={true}
      >
        {modalContent && (
          <div className="row text-center justify-content-around p-2">
            <div className="col-md-5 my-2">
              <div
                onClick={handleNewTeam}
                className={`card card-animation d-flex align-items-center p-5`}
                style={{ borderRadius: "15px" }}
              >
                <h1 style={{ fontSize: "50px" }}>
                  <i className="fa-solid fa-user-plus"></i>
                </h1>
                <h2>Criar time</h2>
              </div>
            </div>
            {permissions &&
              permissions.includes("100") && ( // Importar Times
                <div className="col-md-5 my-2">
                  <div
                    onClick={handleSelect}
                    className={`card card-animation d-flex align-items-center p-5`}
                    style={{ borderRadius: "15px" }}
                  >
                    <h1 style={{ fontSize: "50px" }}>
                      <i className="fa-solid fa-users"></i>
                    </h1>
                    <h2>Importar Times</h2>
                  </div>
                </div>
              )}
          </div>
        )}

        {showSelects && (
          <div className="row">
            <div
              className="col-12 text-muted"
              onClick={() => {
                setModalContent(true);
                setShowSelects(false);
                setNewTeam(false);
              }}
            >
              <h5 className="mt-2" style={{ cursor: "pointer" }}>
                <i
                  className="fa-solid fa-chevron-left mt-2 me-2"
                  style={{ cursor: "pointer", fontSize: "15px" }}
                ></i>
                Voltar
              </h5>
            </div>
            <div className="col-md-4 mb-2 form-group">
              <Select
                name="enterprise_id"
                label={
                  isLoadingEnterprises ? "Carregando..." : "Empreendimento"
                }
                control={form.control}
                disabled={isLoadingEnterprises}
                isRequired={true}
                onChange={(e) => handleEnterprise(e)}
                options={enterprise.filter(
                  (item) => item.value !== parseInt(id)
                )}
                errors={errors}
              />
            </div>

            <div className="col-md-4 mb-2 form-group">
              <MultipleSelect
                disabled={!showTeams}
                name="team"
                label={`${loadingTeams ? "Carregando..." : "Times"}`}
                control={form.control}
                options={teamsSelected}
                onChange={(e) => handleTeams(e)}
              />
            </div>
            {showButton && (
              <div className="col-md-12 text-end mt-3">
                <Button
                  label="Continuar"
                  type="button"
                  onClick={handleSelectedForeignTeamsFn}
                  loading={loadingLinkTeam}
                />
              </div>
            )}
          </div>
        )}

        {newTeam && (
          <div className="row">
            <div
              className="col-12 text-muted"
              onClick={() => {
                setModalContent(true);
                setShowSelects(false);
                setNewTeam(false);
              }}
            >
              <h5 className="mt-2" style={{ cursor: "pointer" }}>
                <i
                  className="fa-solid fa-chevron-left mt-2 me-2"
                  style={{ cursor: "pointer", fontSize: "15px" }}
                ></i>
                Voltar
              </h5>
            </div>
            <div className="col-md-8 mt-1">
              <span className="p-float-label">
                <InputText
                  id="username"
                  value={nameTeam}
                  className="w-100 form-control mt-3"
                  onChange={(e) => setNameTeam(e.target.value)}
                />
                <label htmlFor="username">Nome do time</label>
              </span>
            </div>
            <div className="col-md-2 mt-4">
              <ColorPicker
                format="hex"
                tooltip="Clique para escolher a cor do time"
                value={color}
                onChange={(e) => setColor(e.value)}
              />
            </div>
            <div className="text-end">
              <div className=" text-end mt-3">
                <Button
                  label="Salvar"
                  loading={loading}
                  autoFocus
                  type="submit"
                  onClick={addEmptyTeam}
                />
              </div>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
}

export default Teams;
